module.exports = __webpack_public_path__ + "media/images/WFC_Award_Black_w_0-4d3009caceb0ec73eb8000f5a88496f0.svg";